import axios from 'axios'

const backendURL = process.env.VUE_APP_WEBHOOK_URL

export default {
    namespaced: true,
    state: {
        list: [],
    },
    mutations: {
        SET_ORGANISATION_LIST(state, organisations){
            state.list = (organisations || [])
        },
    },
    actions: {
        async getList({ commit }){
            // Get public list via the webhook
            axios.get(backendURL + '/getOrganisations')
            .then(res => {
                commit('SET_ORGANISATION_LIST', res.data)
            })
            .catch(err => {
                commit('SET_ORGANISATION_LIST', [])
            })
        },
    }
}